import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Card, Spinner, Alert } from 'react-bootstrap';
import { API_CONFIG } from '../../config/api';

const ServiceCentre = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [centres, setCentres] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Use a timeout to debounce the search and avoid excessive API calls
    const debounceTimer = setTimeout(() => {
      setLoading(true);
      setError(null);

      // Append the search term as a query parameter
      const url = `${API_CONFIG.SERVICE_CENTERS_URL}?search=${encodeURIComponent(searchTerm)}`;

      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          setCentres(data.data);
        })
        .catch(error => {
          console.error('Error fetching service centres:', error);
          setError('Failed to load service centers. Please make sure the backend server is running and accessible.');
        })
        .finally(() => {
          setLoading(false);
        });
    }, 500); // 500ms debounce delay

    // Cleanup function to clear the timer if the component unmounts or searchTerm changes
    return () => clearTimeout(debounceTimer);
  }, [searchTerm]); // Re-run effect when searchTerm changes

  return (
    <Container className="py-5">
      <h1 className="text-center mb-5">Find a Service Centre</h1>

      <Row className="mb-4 justify-content-center">
        <Col md={8}>
          <Form.Control
            type="text"
            placeholder="Search by city or center name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </Col>
      </Row>

      <Row>
        {loading && (
          <Col className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </Col>
        )}

        {error && (
          <Col>
            <Alert variant="danger">{error}</Alert>
          </Col>
        )}

        {!loading && !error && centres.length === 0 && (
          <Col>
            <Alert variant="info">
              {searchTerm ? `No service centers found for "${searchTerm}".` : 'Enter a search term to find service centers.'}
            </Alert>
          </Col>
        )}

        {!loading && !error && centres.map(centre => (
          <Col key={centre.id} md={6} lg={4} className="mb-4">
            <Card className="h-100">
              <Card.Body>
                <Card.Title>{centre.name}</Card.Title>
                <Card.Text>
                  {centre.address}<br />
                  {centre.city}, {centre.state}<br />
                  {centre.phone && <><strong>Phone:</strong> {centre.phone}<br /></>}
                  {centre.email && <><strong>Email:</strong> {centre.email}</>}
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default ServiceCentre;
